// extracted by mini-css-extract-plugin
module.exports = {"body":"SwitchItem_body__3S8pb","card":"SwitchItem_card__1to8w"};